import React, { useRef } from "react";
import Autocomplete from "react-google-autocomplete";

const GooglePlacesMulti = ({
  setHomeCourtAddressField,
  homeCourtAddressField,
  fieldNames,
  ...props
}) => {
  const handleError = (error) => {
    console.error("Error selecting place:", error);
  };
  const autocompleteRef = useRef(null);

  const handleInputBlur = () => {
    // If the input field loses focus and is empty, clear the selected place
    if (autocompleteRef.current && !autocompleteRef.current.value) {
      const emptyFields = {};
      fieldNames.forEach((name) => {
        emptyFields[name] = "";
      });
      setHomeCourtAddressField((prev) => [emptyFields]); // Reset to an array with empty fields
    }
  };

  return (
    <Autocomplete
      ref={autocompleteRef}
      apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
      className="form-control"
      defaultValue={homeCourtAddressField}
      onPlaceSelected={(place) => {
        const location = place?.formatted_address;
        const lat = place?.geometry?.location.lat();
        const lng = place?.geometry?.location.lng();

        const updatedFields = {
          home_court_address: location,
          home_court_latitude: lat,
          home_court_longitude: lng,
        };

        // Check if the field at index exists, if so, update it; otherwise, add a new field
        setHomeCourtAddressField((prev) => {
          const newFields = [...prev];
          const indexToUpdate = newFields.findIndex(
            (field) => field.home_court_address === ""
          );
          if (indexToUpdate !== -1) {
            newFields[indexToUpdate] = updatedFields;
          } else {
            newFields.push(updatedFields);
          }
          return newFields;
        });

        // setValidationErrors({ location: "" });
      }}
      onBlur={handleInputBlur}
      onError={handleError}
    />
  );
};

export default GooglePlacesMulti;
